// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3ZFLr","label":"Section_label__57048","contentWrap":"Section_contentWrap__1afgD","footer":"Section_footer__3P4eL","footerInner":"Section_footerInner__nOiXl"};